import React, { useState, useEffect } from "react";
import "./index.less";
import { Button, Dropdown, Form, message, } from 'antd';
import { request, setUser } from "@/utils";
import { Func } from "@/utils/func";
import IconPswon from '@/assets/icon-psw-on.png'
import IconPswoff from '@/assets/icon-psw-off.png'
import { useNavigate } from "react-router-dom";
import { DownOutlined } from "@ant-design/icons";
export default function ResetPwd() {
    const [countdown, setCountdown] = useState(60); // 初始倒计时值
    const [isCounting, setIsCounting] = useState(false); // 标志是否在倒计时中
    const [form] = Form.useForm(); // 创建表单实例
    const [params, setParams] = useState({ mobile: null, code: null, password: null })
    const [info, setInfo] = useState({})
    const navigate = useNavigate();
    const onFinish = async () => {
        if (!params.mobile) {
            message.error('请输入手机号码')
            return false
        }
        if (!params.code) {
            message.error('请输入手机验证码')
            return false
        }
        const response = await request.post('auth/change-mobile', {
            id:info.id,
            mobile: params.mobile,
            code: params.code,
        });
        if (response.code) {
            message.success(response.msg)
        } else {
            message.success('手机号码修改成功')
            navigate(-1)
        }
    };
    const startCountdown = () => {
        setIsCounting(true);
        const interval = setInterval(() => {
            setCountdown((prevCount) => {
                if (prevCount <= 1) {
                    clearInterval(interval);
                    setIsCounting(false);
                    setCountdown(60)
                }
                return prevCount - 1;
            });
        }, 1000);
    };

    const handleSendCode = () => {
        if (!params.mobile) {
            message.error('请输入手机号码')
            return false
        }
        try {
            const phoneNumber = params.mobile;
            console.log(phoneNumber);
            // 手机号码验证，你可以根据实际需求修改验证规则
            const response = request.post('auth/mobile-code', {
                mobile: phoneNumber,
                type: 3,
                nation_code:areaCode
            });
            // 这里使用 setTimeout 模拟异步操作
            message.success('验证码已发送');
            startCountdown();
        } catch (errorInfo) {
            console.log('Failed:', errorInfo);
        }
    };
    const fetchData = async (page, perPage) => {
        try {
            const response = await request.get('auth/info'); // 使用封装好的Axios实例发送GET请求
            if (response.code) {
                message.error(response.msg)
            } else {
                setInfo(response.data)
                setUser(response.data)
            }
        } catch (error) {
            console.error('Failed to fetch data:', error);
        }
    };
    useEffect(() => {
        fetchData();
    }, [])
    const [areaCode, setAreaCode] = useState('86')
    const items = [
        {
            key: '1',
            label: (
                <div className='arecode' onClick={() => { setAreaCode('86') }}>
                    <span className='code'> +86 </span><span>中国大陆</span>
                </div>
            ),
        },
        {
            key: '2',
            label: (
                <div className='arecode' onClick={() => { setAreaCode('852') }}>
                    <span className='code' > +852 </span><span>中国香港</span>
                </div>
            ),

        },
        {
            key: '3',
            label: (
                <div className='arecode' onClick={() => { setAreaCode('886') }}>
                    <span className='code'> +886 </span><span>中国台湾</span>
                </div>
            ),
        },
        {
            key: '4',
            label: (
                <div className='arecode' onClick={() => { setAreaCode('853') }}>
                    <span className='code'> +853 </span><span>中国澳门</span>
                </div>
            ),
        },
        {
            key: '5',
            label: (
                <div className='arecode' onClick={() => { setAreaCode('81') }}>
                    <span className='code'> +81 </span><span>日本</span>
                </div>
            ),
        },
    ];
    return (
        <div className="updatePassword">
            <div className="updatePassword-container">
                <div className="back" onClick={() => navigate(-1)}>返回 </div>
                <div className="updatePassword-form">
                    <div className="title">修改号码</div>
                    <div className='label'>手机号码</div>
                    <div className="phone-input mg20">
                        <Dropdown menu={{ items }} trigger={['click']}>
                            <div className='areaCode'>
                                <div className='codeValue' >+{areaCode}</div>
                                <DownOutlined style={{ fontSize: '14px' }} />
                            </div>
                        </Dropdown>
                        <input placeholder="请输入手机号码" size="large" value={params.mobile} onInput={(e) => {
                                params.mobile = e.target.value
                                setParams({ ...params })
                            }}/>
                    </div>
                    <div className='label'>手机验证码</div>
                    <div className='sendCode'>
                        <div className="phone-input">
                            <input placeholder="请输入手机验证码" size="large" value={params.code} onInput={(e) => {
                                params.code = e.target.value
                                setParams({ ...params })
                            }} />
                        </div>
                        <Button
                            className='sender-code'
                            type="primary"
                            size="large"
                            onClick={handleSendCode}
                            disabled={isCounting}
                            style={{ backgroundColor: isCounting ? '#f9f5ef' : '', color: isCounting ? '#C59D60' : '' }}
                        > {isCounting ? `${countdown}S后重发` : '发送验证码'}</Button>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '50px' }}>
                        <Button
                            style={{
                                width: "120px",
                                height: "40px",
                                marginRight: "31px",
                                marginBottom: "25px",
                                fontSize: "14px",
                                borderRadius: "4px",
                            }}
                            onClick={() => { navigate(-1) }}>取消</Button>
                        <Button
                            type="primary" htmlType="submit"
                            style={{
                                width: "120px",
                                height: "40px",
                                marginBottom: "25px",
                                fontSize: "14px",
                                borderRadius: "4px",
                            }} onClick={onFinish}>确定</Button>
                    </div>

                </div>
            </div>

        </div>
    );

}

